import { render, staticRenderFns } from "./TechnicalAssessmentPage.vue?vue&type=template&id=3c450131&scoped=true"
import script from "./TechnicalAssessmentPage.vue?vue&type=script&lang=js"
export * from "./TechnicalAssessmentPage.vue?vue&type=script&lang=js"
import style0 from "./TechnicalAssessmentPage.vue?vue&type=style&index=0&id=3c450131&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c450131",
  null
  
)

export default component.exports